import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ThemePalette } from '@angular/material';
import { IChangeSignFieldTypeEvent } from '@app/transaction-builder/model/sign-field-events.model';
import { IClientSignField } from '@app/transaction-builder/model/sign-field.model';
import { ITxFormClientData } from '@app/transaction-builder/model/transaction-form-data.model';
import { SignatureType } from 'ngx-mat-esign360';

@Component({
  selector: 'app-editable-sign-field',
  templateUrl: './editable-sign-field.component.html',
  styleUrls: ['./editable-sign-field.component.scss'],
})
export class EditableSignFieldComponent implements OnInit {
  @Input() signField: IClientSignField;
  @Input() signer: ITxFormClientData;
  @Input() color: ThemePalette;
  @Input() active: boolean;
  @Output() clickContent = new EventEmitter<IClientSignField>();
  @Output() deleteSignField = new EventEmitter<IClientSignField>();
  @Output() changeSignFieldType = new EventEmitter<IChangeSignFieldTypeEvent>();
  @Output() finishSignFieldEdit = new EventEmitter<IClientSignField>();

  constructor() {}

  ngOnInit(): void {}

  onChangeSignFieldType(signField: IClientSignField, type: SignatureType) {
    this.changeSignFieldType.emit({
      signField,
      type,
    });
  }
}
